// extracted by mini-css-extract-plugin
export var avatar = "_oy-3";
export var avatarContainer = "_oy-2";
export var avatarSpacer = "_oy-5";
export var avatarSpacerContainer = "_oy-4";
export var avatarStackContainer = "_oy-1";
export var bubble = "_oy-0";
export var remainderBubble = "_oy-6";